export default "__VITE_ASSET__CRICqa7g__"